export default __webpack_public_path__ + "static/portrait3-1ab9f7254a826bd003d8248bcf527c89.jpg";